/* eslint-disable react/prop-types */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-param-reassign */
/* eslint-disable @scandipwa/scandipwa-guidelines/only-render-in-component */
/* eslint-disable @scandipwa/scandipwa-guidelines/create-config-files */
/*
 * @category  Puma
 * @author    Deniss Dubinins <denissd@scandiweb.com | info@scandiweb.com>
 * @license   http://opensource.org/licenses/OSL-3.0 The Open Software License 3.0 (OSL-3.0)
 * @copyright Copyright (c) 2022 Scandiweb, Inc (https://scandiweb.com)
 */

import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import FIELD_TYPE from 'Component/Field/Field.config';
import Field from 'SourceComponent/Field';
import Form from 'SourceComponent/Form';

import { isNationalIdNumberEnabled } from '../../util/NationalIdNumber';

import './NationalIdNumber.style.scss';

export const NATIONAL_ID_LENGTH = 10;

/** @namespace Nationalidnumber/Component/NationalIdNumber/Component */
export class NationalIdNumberComponent extends PureComponent {
    static propTypes = {
        onChange: PropTypes.func.isRequired,
        national_id_number_initial_value: PropTypes.string
    };

    static defaultProps = {
        national_id_number_initial_value: ''
    };

    __construct() {
        this.onKeyPress = this.onKeyPress.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
        this.onPaste = this.onPaste.bind(this);
    }

    onKeyUp({ key }) {
        if (this.controlButtonActive) {
            this.controlButtonActive = key === 'Control' || key === 'Meta';
        }
    }

    onPaste({ target }) {
        setTimeout(() => {
            target.value = target.value.replace(/\D/g, '').substring(0, NATIONAL_ID_LENGTH);
        }, 0);
    }

    onKeyPress(event) {
        const { key, target: { value } } = event;
        const isNumber = isFinite(key === ' ' ? 'Space' : key);
        const whitelist = ['Backspace', 'Delete', 'ArrowDown', 'ArrowUp', 'ArrowRight', 'ArrowLeft', 'Meta', 'Control'];
        const whitelistKey = whitelist.includes(key);

        if (
            ((!isNumber && !whitelistKey) || (value.length === NATIONAL_ID_LENGTH && !whitelistKey))
            && !this.controlButtonActive
        ) {
            event.preventDefault();
        }

        if (!this.controlButtonActive) {
            this.controlButtonActive = key === 'Control' || key === 'Meta';
        }
    }

    render() {
        if (!isNationalIdNumberEnabled()) {
            return null;
        }

        const { onChange, national_id_number_initial_value } = this.props;

        return (
            <div className="FieldForm CheckoutAddressForm">
                <Form
                  attr={ {
                      name: 'CheckoutNationalIdNumberForm'
                  } }
                  mix={ { block: 'CheckoutNationalIdNumberForm' } }
                >
                    <Field
                      type={ FIELD_TYPE.text }
                      label={ __('National ID number') }
                      attr={ {
                          id: 'national_id_number',
                          name: 'national_id_number',
                          defaultValue: national_id_number_initial_value
                      } }
                      placeholder={ __('National ID number') }
                      validateOn={ ['onChange'] }
                      validationRule={ {
                          isRequired: true,
                          range: {
                              min: NATIONAL_ID_LENGTH
                          },
                          customErrorMessages: {
                              onRangeFailMin: __('Please enter the exact 10 numbers from your national ID')
                          }
                      } }
                      events={ {
                          onChange,
                          onKeyDown: this.onKeyPress,
                          onPaste: this.onPaste,
                          onKeyUp: this.onKeyUp
                      } }

                    />
                </Form>
            </div>
        );
    }
}

export default NationalIdNumberComponent;
